import { render } from "./View712.vue?vue&type=template&id=40a10812"
import script from "./View712.vue?vue&type=script&lang=js"
export * from "./View712.vue?vue&type=script&lang=js"

import "./View712.vue?vue&type=style&index=0&id=40a10812&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__